import { get } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS, APP_V2_USER_EVENTS, useToast } from "@src/appV2/lib";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const SEND_AGREEMENT_EMAIL_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/agentprofile/agreement`;

export function useSendAgreementEmail(options: UseMutationOptions<unknown, AxiosError> = {}) {
  const { showSuccessToast, showErrorToast } = useToast();

  return useMutation({
    mutationFn: async () => {
      await get({
        url: SEND_AGREEMENT_EMAIL_URL,
        queryParams: { sendToEmail: true },
        responseSchema: z.string(),
      });
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.SEND_AGREEMENT_EMAIL_FAILURE,
      logSuccessMessage: APP_V2_USER_EVENTS.SEND_AGREEMENT_EMAIL_SUCCESS,
    },
    onSuccess: () => {
      showSuccessToast("The contract has been sent!");
    },
    onError: () => {
      showErrorToast("There was an error on sending the contract");
    },
    ...options,
  });
}
